import type { Pixel, PixelStayTime } from 'sonata-static-storage/lib/schemas/pixel/pixel.schema';

export function getPixelCode(pixel: Pixel & Record<string, any>): string {
  let code = '';
  if (pixel.type === 'conversion') {
    if (!pixel.codeType || pixel.codeType === 'image') {
      code = `<img src="${taptap.config.adserverPixelTracks.conversion.image}/${pixel._id}" alt="." />`;
    } else {
      code = `<script type="text/javascript" src="${taptap.config.adserverPixelTracks.conversion.script[pixel.positionType || 'persist']}"></script>`;
    }
  } else if (!pixel.placement) {
    code = `<script type="text/javascript" src="${taptap.config.adserverPixelTracks.stay.script.v1}/${pixel._id}"></script>`;
  } else {
    code = `<script type="text/javascript" src="${taptap.config.adserverPixelTracks.stay.script.v2}/${pixel._id}"></script>`;
  }

  return code;
}

export async function copyPixelCodeToClipboard({ pixel }: Record<string, any>): Promise<void> {
  const code = getPixelCode(pixel);
  await navigator.clipboard.writeText(code);
}

export function getPermanenceDefaultStayFeatures(): PixelStayTime[] {
  const permanenceFeatures = [5, 10, 15, 30, 60, 90, 120];
  return permanenceFeatures.map(time => ({
    name: `${time}s`,
    time: time * 1000
  }));
}
